<template>
  <div>
    <div class="top-bar">
      <span>
        <i class="left" @click="back()"></i>
      </span>
      <span class="heading_new">Upload forms and submit</span>
      <span class="spacer" />
    </div>

    <div class="main-container">
      <div class="row">
        <div class="col-4">
            <div class="upload-heading">Upload Form 12BB</div>
          <upload />
        </div>
        <div class="col-4">
            <div class="upload-heading">Joint Property</div>
          <upload />
        </div>
      </div>
      <bottom-action-container>
        <template slot="end">
          <btn-grp>
            <btn text="Cancel" type="secondary" @click="back"/>
            <btn text="Submit" type="primary" @click="finalSubmit()" />
          </btn-grp>
        </template>
      </bottom-action-container>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  methods: {
    back() {
      this.$router.go(-1);
    },
    finalSubmit(){
        this.$router.push({
        path: `/dashboard/${this.$route.params.entity_index}/organisation/utilities/importdeclarations`,
        query:{id:this.$route.query.id, status:'uploaded'}
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.container-width {
  width: 300px;
}
.top-bar {
  height: auto;
  padding: 20px;
  background-color: #34c0be;
  display: flex;
}
.heading_new {
  width: auto;
  font-size: 24px;
  font-weight: bold;
  color: #ffffff;
  height: auto;
}
.left {
  border: solid white;
  border-width: 0 2px 2px 0;
  padding: 5px;
  transform: rotate(135deg);
  -webkit-transform: rotate(135deg);
  margin-top: 9px;
  margin-right: 15px;
  cursor: pointer;
}

.d_heading {
  font-size: 14px;
  font-weight: 600;
  color: #646464;
}
.upload-heading {
  font-size: 13px;
  font-weight: 500;
}
</style>


